<template>
  <v-container fluid class="py-0 ml-5 calendar-filter">
    <v-row>
      <h4 class="year">{{ currentMonth.toFormat('yyyy') }}</h4>
    </v-row>
    <v-row align="center">
      <v-menu
        v-model="menu"
        class="date-picker"
        :disabled="$wait.is('calendar-metrics')"
        transition="scale-transition"
        :close-on-content-click="false"
        offset-y
        :nudge-right="40"
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <h4 class="month" v-on="on">{{ capitalize(currentMonth.setLocale('pt-BR').toFormat('MMMM')) }}</h4>
        </template>
        <v-date-picker class="calendario-mes" :value="currentMonth.toFormat('yyyy-MM')" color="primary" type="month" locale="pt-BR" @input="inputDatePicker" />
      </v-menu>

      <mf-button class="ml-4" color="cinza-0" type="icon" icon="keyboard_arrow_left" :disabled="disabled" @click="previousMonth" />
      <mf-button class="ml-2" color="cinza-0" type="icon" icon="keyboard_arrow_right" :disabled="disabled" @click="nextMonth" />

      <v-spacer />
      <div v-for="(type, index) in campaignTypes" :key="index">
        <div class="campaign-type" :class="[type.mode, type.selected ? 'selected' : '']" @click="selectType(index)">
          <div class="color-box" :class="type.mode" />
          {{ type.name }}
        </div>
      </div>
      <div>
        <div class="campaign-type maria" :class="[isMariaSelected ? 'selected' : '']" @click="selectMariaType()">
          <div class="color-box maria" />
          Campanha da mar.ia
        </div>
      </div>
    </v-row>
  </v-container>
</template>

<script>
import capitalize from 'lodash/capitalize'
import { mapActions, mapState } from 'vuex'
import { DateTime } from 'luxon'

export default {
  props: {
    disabled: Boolean,
  },
  data: () => ({
    menu: false,
    isMariaSelected: false,
    capitalize: capitalize,
    campaignTypes: [
      {
        name: 'WhatsApp',
        mode: 'whatsapp',
        selected: false,
      },
      {
        name: 'SMS',
        mode: 'sms',
        selected: false,
      },
      {
        name: 'E-mail',
        mode: 'email',
        selected: false,
      },
      {
        name: 'Push aplicativo',
        mode: 'push',
        selected: false,
      },
    ],
  }),
  computed: {
    ...mapState({
      currentMonth: (state) => state.calendarioPromocional.currentMonth,
    }),
  },
  created() {
    this.updateCurrentMonth(DateTime.now())
  },
  methods: {
    ...mapActions(['updateCurrentMonth', 'updateSelectedModes', 'updateMariaSelected']),
    selectType(index) {
      if (this.disabled) {
        return
      }
      this.campaignTypes[index].selected = !this.campaignTypes[index].selected
      const modes = this.campaignTypes.filter((obj) => obj.selected).map((obj) => obj.mode.toUpperCase())

      this.updateSelectedModes(modes.filter((obj) => obj !== 'suggestion'))
    },
    selectMariaType() {
      if (this.disabled) return
      this.isMariaSelected = !this.isMariaSelected
      this.updateMariaSelected(this.isMariaSelected)
    },
    previousMonth() {
      this.updateCurrentMonth(DateTime.fromISO(this.currentMonth).plus({ months: -1 }))
    },
    nextMonth() {
      this.updateCurrentMonth(DateTime.fromISO(this.currentMonth).plus({ months: 1 }))
    },
    inputDatePicker(value) {
      this.menu = false
      this.updateCurrentMonth(DateTime.fromFormat(value, 'yyyy-MM'))
    },
  },
}
</script>

<style lang="scss">
$chatbot-color: #e67e22;
$chatbot-opacity-color: rgba(243, 156, 18, 0.2);

$whatsapp-color: #27ae60;
$whatsapp-opacity-color: rgba(39, 174, 96, 0.2);

$sms-color: #3498db;
$sms-opacity-color: rgba(52, 152, 219, 0.2);

$email-color: #e74c3c;
$email-opacity-color: rgba(231, 76, 60, 0.2);

$push-color: #8e44ad;
$push-opacity-color: rgba(142, 68, 173, 0.2);

$maria-color: #ffc700;
$maria-opacity-color: rgba(145, 113, 0, 0.2);

$suggestion-color: rgba(0, 0, 0, 0.8);
$suggestion-opacity-color: rgba(0, 0, 0, 0.1);

.calendario-mes {
  .v-date-picker-title {
    text-transform: capitalize !important;
  }
}

.calendar-filter {
  .year {
    opacity: 0.8;
    font-size: 12px;
    font-weight: normal;
    line-height: 1.25;
    letter-spacing: 0.19px;
    user-select: none;
  }
  .month {
    width: 175px;
    user-select: none;
    cursor: pointer;
    opacity: 0.8;
    font-size: 36px;
    font-weight: bold;
    line-height: 1.22;
    letter-spacing: 0.58px;
  }

  .campaign-type {
    user-select: none;
    margin-right: 8px;
    padding: 2px 6px;
    height: 28px;
    border: 1px solid transparent;
    transition: border linear 100ms;
    transition: all linear 100ms;
    border-radius: 20px;
    cursor: pointer;

    &:hover {
      &.whatsapp {
        border-color: $whatsapp-color;
      }
      &.chatbot {
        border-color: $chatbot-color;
      }
      &.sms {
        border-color: $sms-color;
      }
      &.email {
        border-color: $email-color;
      }
      &.push {
        border-color: $push-color;
      }
      &.suggestion {
        border-color: $suggestion-color;
      }
    }

    .color-box {
      height: 14px;
      width: 14px;
      margin-bottom: -1.5px;
      display: inline-block;
      border-radius: 3px;

      &.whatsapp {
        background-color: $whatsapp-color;
      }
      &.chatbot {
        background-color: $chatbot-color;
      }
      &.sms {
        background-color: $sms-color;
      }
      &.email {
        background-color: $email-color;
      }
      &.push {
        background-color: $push-color;
      }
      &.maria {
        background-color: $maria-color;
      }
      &.suggestion {
        background-color: $suggestion-color;
      }
    }

    &.selected {
      &.whatsapp {
        border-color: $whatsapp-color;
        background-color: $whatsapp-opacity-color;
      }

      &.chatbot {
        border-color: $chatbot-color;
        background-color: $chatbot-opacity-color;
      }
      &.sms {
        border-color: $sms-color;
        background-color: $sms-opacity-color;
      }
      &.email {
        border-color: $email-color;
        background-color: $email-opacity-color;
      }
      &.push {
        border-color: $push-color;
        background-color: $push-opacity-color;
      }
      &.maria {
        border-color: $maria-color;
        background-color: $maria-opacity-color;
      }
      &.suggestion {
        border-color: $suggestion-color;
        background-color: $suggestion-opacity-color;
      }
    }
  }
}
</style>
